module.exports = __webpack_public_path__ + "FSAlbert-BoldItalic.ef7bc3207e71efc1225b.otf";


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/fonts/fsAlbert/FSAlbert-BoldItalic.otf
// module id = ../../../../../src/assets/fonts/fsAlbert/FSAlbert-BoldItalic.otf
// module chunks = main